module.exports = __webpack_public_path__ + "static/media/cam_icon.73949a95.svg";